import TagsCard from './TagsCard';

export default TagsCard;
